var welcome = $(".input-region").eq(0).val();
var language = document.cookie.replace(/(?:(?:^|.*;\s*)language\s*\=\s*([^;]*).*$)|^.*$/, "$1");
var d = new Date();
d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
var expires = "expires=" + d.toUTCString();

$(document).ready(function () {
    $(".choose-language .region").removeClass("languages__current");
    console.log("language activate");

    if (language.length == 0) {
        document.cookie = "language=" + welcome + ";" + expires + "; path=/";
        $(".choose-language .region[data-language=" + welcome + "]").addClass("active");
        renewChooseLanguage();
    } else {
        renewChooseLanguage();
    }

    $(".dropdown-content .region").on("click", function (e) {
        e.preventDefault();
        welcome = $(this).data("region");
        document.cookie = "language=" + welcome + ";" + expires + "; path=/";

        if (!$(this).hasClass("languages__current")) {
            // 👉 Lấy URL hiện tại
            let currentUrl = window.location.href;
            let urlObj = new URL(currentUrl);
            let segments = urlObj.pathname.split('/');

            // 👉 Nếu segment đầu tiên là mã ngôn ngữ (vd: /vn/...)
            if (segments[1].length === 2 && /^[a-z]{2}$/i.test(segments[1])) {
                segments[1] = welcome;
            } else {
                // Nếu không, chèn mã ngôn ngữ vào sau domain
                segments.splice(1, 0, welcome);
            }

            // 👉 Gắn lại đường dẫn mới
            urlObj.pathname = segments.join('/');
            console.log("Redirecting to: " + urlObj.toString());
            window.location.href = urlObj.toString();
        }
    });
});

function renewChooseLanguage() {
    var x = document.cookie.replace(/(?:(?:^|.*;\s*)language\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    var chosenNationText = $(".choose-language .region[data-region=" + x + "]")
        .eq(0)
        .text();
    var chosenLang = x;
    let keyName = {
        en: "EN",
        vn: "VN",
        th: "TH",
        id: "ID",
        cn: "CN",
    };
    $(".current").html(keyName[chosenLang] || chosenLang.toUpperCase());
    $(".currentInput").attr("data-region", chosenLang);
    $(".choose-language .region[data-region=" + x + "]").parent().addClass("active");
}
